/**
 * @generated SignedSource<<9354845cba7fb9afb492f6d8a9cba25f>>
 * @relayHash 37cd37066cb4156054a7671e5c63c783
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f7e8562a5bbf95824afd54dbfdcac6812d76eb6eedb52e6171dc6a3194c0d04

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1f7e8562a5bbf95824afd54dbfdcac6812d76eb6eedb52e6171dc6a3194c0d04",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
